import { Archive } from "lucide-react";
import { useNotify, useRecordContext, useRefresh, useUpdate } from "ra-core";
import { Button } from "@/components/ui/button";
import type { Campaign } from "../types";

export function CampaignArchiveButton({
  record: recordProp,
}: {
  record?: Campaign;
}) {
  const recordFromContext = useRecordContext<Campaign>();
  const record = recordProp || recordFromContext;
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { isPending }] = useUpdate("campaigns");

  if (!record || record.archived_at) {
    return null;
  }

  const handleArchive = (e: React.MouseEvent) => {
    e.stopPropagation();
    update(
      "campaigns",
      {
        id: record.id,
        data: { archived_at: new Date().toISOString() },
        previousData: record,
      },
      {
        onSuccess: () => {
          notify("resources.campaigns.archived.success", {
            type: "info",
            messageArgs: { _: "Campanha arquivada" },
          });
          refresh();
        },
        onError: () => {
          notify("resources.campaigns.archived.error", {
            type: "error",
            messageArgs: { _: "Erro ao arquivar campanha" },
          });
        },
      },
    );
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleArchive}
      disabled={isPending}
      className="gap-1 text-destructive hover:text-destructive"
    >
      <Archive className="h-4 w-4" />
      <span>Arquivar</span>
    </Button>
  );
}
